module.exports = __webpack_public_path__ + "img/icon-nav-logo.ed55c977.png";